<template>
  <div class="chevron-counter">
    <input type="number" autocomplete="off" :value="value" @input="$emit('input', $event.target.value)" @keyup="$emit('keyup')">
    <div class="chevron-counter-buttons">
      <img src="@/assets/icons/chevron-up.svg" @click="change(value)"/>
      <img src="@/assets/icons/chevron-up.svg" style="transform: rotate(180deg)" @click="change(value,false)"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-chevron-counter",
  props:{
    value: {
      type:[String, Number],
      default: 0
    }
  },
  methods:{
    change(value, inc = true){
      if(inc){
        if(value+1 > 9999) return;
        value++
      }else{
        if(value-1 < 0) return;
        value--
      }
      this.$emit('input', value)
        this.$emit('keyup')
      }
  }
}
</script>

<style scoped lang="scss">
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type='number'],
  input[type="number"]:hover,
  input[type="number"]:focus {
    appearance: none;
    -moz-appearance: textfield;
  }
  .chevron-counter{
    max-width: 60px;
    border: 1px solid #B6BCC8;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    & input{
      padding-top: 3px;
      width: 100%;
      background: transparent;
      border: none;
      text-align: right;
    }

    &-buttons{
      margin-left: 3px;
      margin-right: 3px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      & img{
        cursor: pointer;
      }

      & :first-child{
        margin-bottom: 3px;
      }
    }
  }
</style>
